module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/9-5e5e380a27bb218e8a36f157183ec8a9.jpg";